export const createRoundAnalyzerUrl = (roundName: string, shotNumber: number, deviceId: string): string => {
    return `/#/round?round-name=${roundName}&shot-nr=${shotNumber}&device-id=${deviceId}`;
}